export type ResponsiveWorkspacePanel = 'pages' | 'inspector';

export type AnimationFrameScheduler = (callback: FrameRequestCallback) => number;

export const closeResponsivePanelAndRestoreFocus = (
  panel: ResponsiveWorkspacePanel,
  collapse: (panel: ResponsiveWorkspacePanel) => void,
  resolveToggle: (panel: ResponsiveWorkspacePanel) => HTMLElement | null,
  schedule: AnimationFrameScheduler = window.requestAnimationFrame.bind(window)
): number => {
  collapse(panel);
  return schedule(() => resolveToggle(panel)?.focus());
};

export const handleResponsivePanelEscape = (
  event: Pick<KeyboardEvent, 'key' | 'preventDefault'>,
  activePanel: ResponsiveWorkspacePanel | null,
  closePanel: (panel: ResponsiveWorkspacePanel) => void
): boolean => {
  if (event.key !== 'Escape' || !activePanel) return false;
  event.preventDefault();
  closePanel(activePanel);
  return true;
};
